import React, { FC } from 'react';
import { Formik } from 'formik';
import { PriceSummary } from './PriceSummary';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { AddonListActions, Product, ProductListActions } from '../../../types/webshop';
import { DefaultBottomBar } from '../BottomBar/DefaultBottomBar';
import { Step } from '../Step';
import { FormikPersist } from '../../Common/FormikPersist';

interface SummaryStepProps {
  selectedProducts: Product[];
  selectedProductsActions: ProductListActions;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  price: string;
  vatPrice: string;
  selectedCategoryKey?: string;
  selectedSubcategoryKey?: string;
  summaryFormComment: string;
  setSummaryFormComment: React.Dispatch<React.SetStateAction<string>>;
  nextButtonClicked: () => void;
  cmsShopContent: ShopContent;
  registerOnBack?: (callback: () => void) => void;
}

interface SummaryFormValues {
  selectedSubcategoryKey?: string;
  summaryFormInputs: string;
}

export const SummaryStep: FC<SummaryStepProps> = ({
  selectedProducts,
  selectedProductsActions,
  selectedAddons,
  selectedAddonsActions,
  price,
  vatPrice,
  selectedCategoryKey,
  selectedSubcategoryKey,
  summaryFormComment,
  setSummaryFormComment,
  nextButtonClicked,
  cmsShopContent,
  registerOnBack,
}) => {
  return (
    <Formik
      onSubmit={(values) => {
        setSummaryFormComment(values.summaryFormInputs);
      }}
      initialValues={{
        selectedSubcategoryKey: selectedSubcategoryKey,
        summaryFormInputs: summaryFormComment,
      }}
      validate={() => {
        if (selectedProducts.length === 0) {
          return { error: Error('No products have been selected!') };
        }
      }}
      validateOnMount
    >
      {({ isValid, submitForm }) => (
        <>
          <FormikPersist<SummaryFormValues>
            registerOnBack={registerOnBack}
            onSave={(values) => setSummaryFormComment(values.summaryFormInputs)}
          />
          <Step
            title={cmsShopContent.summaryStep.title}
            subtitle={cmsShopContent.summaryStep.subtitle}
            content={
              <PriceSummary
                selectedProducts={selectedProducts}
                selectedProductsActions={selectedProductsActions}
                selectedAddons={selectedAddons}
                selectedAddonsActions={selectedAddonsActions}
                price={price}
                vatPrice={vatPrice}
                selectedCategoryKey={selectedCategoryKey}
                selectedSubcategoryKey={selectedSubcategoryKey}
                cmsShopContent={cmsShopContent}
              />
            }
            bottomBar={
              <DefaultBottomBar
                continueButtonDisabled={!isValid}
                onClick={async () => {
                  await submitForm();
                  nextButtonClicked();
                }}
                cmsShopContent={cmsShopContent}
                footerContent={cmsShopContent.summaryStep.footer}
              />
            }
          />
        </>
      )}
    </Formik>
  );
};
